import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation RemoveBookmarkedGroupPost($groupPostId: String!) {
    deleteSavedGroupPost(groupPostId: $groupPostId) {
      success
      message
    }
  }
`

export interface RemoveBookmarkedGroupPostMutationInput {
  groupPostId: string
}

export interface RemoveBookmarkedGroupPostMutationOutput {
  deleteSavedGroupPost: {
    success: boolean
    message: string
  }
}

export const useRemoveBookmarkedGroupPost = () =>
  useMutation<RemoveBookmarkedGroupPostMutationOutput, RemoveBookmarkedGroupPostMutationInput>(
    mutation
  )
